module.exports = __webpack_public_path__ + "static/img/23.a887545.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/23.jpg
// module id = xU7w
// module chunks = 0